import FlightSelection from "../../FlightSelection/FlightSelection";
import FlightTitle from "../../FlightTitle";
import PassengerSelection from "../../PassengerSelection/PassengerSelection";
import SSROutlet from "../../../SSROutlet";
import SSRItemTotal from "../../SSRItemTotal";

const SSRContentWeb = () => {
  return (
    <>
      <div className="bg-background-default flex h-full w-full flex-col overflow-hidden rounded-md">
        <div className="flex min-h-0 flex-1 flex-col p-4">
          <div>
            <FlightSelection />
            <FlightTitle />
          </div>
          <div className="flex min-h-0 w-full flex-1 flex-col items-start justify-between gap-4 md:flex-row">
            <div className="w-full flex-2 md:sticky md:top-0">
              <PassengerSelection />
            </div>
            <div className="flex-5 h-full min-h-0 w-full overflow-y-auto">
              <SSROutlet />
            </div>
          </div>
        </div>

        <div className="shadow-bottom-sheet rounded-md p-4">
          <SSRItemTotal />
        </div>
      </div>
    </>
  );
};

export default SSRContentWeb;
